import axios from 'axios';
import { BASE_URL } from '../variables'
// import localStorageObj from './localStorage'
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = "csrftoken"
axios.defaults.xsrfHeaderName = "X-CSRFToken"
// axios.interceptors.request.use(config => {
//     config.baseURL = BASE_URL;
//     let token = localStorageObj._getAccessToken();
//     if (token){

//         config.headers['Authorization'] = `Bearer ${token}`
//     }
//     return config
// }, error => {
//     Promise.reject(error)
// })

// axios.interceptors.response.use(response => {
//     return response
// }, error => {
//     const originalRequest = error.config

//     if (error.response.status === 401 && originalRequest.url === "api/token/refresh/"){ 
//         localStorageObj._clearToken()
//         originalRequest.headers = {};
//         console.log("Afzal Was Here", originalRequest)
//         delete axios.defaults.headers.common["Authorization"]
//         console.clear()
//         return new Promise((resolve, reject) => {
//                 reject(error)
//         })
//     }
//     else if (error.response.status === 401 && !originalRequest._retry){
//         originalRequest._retry = true
//         console.clear()
//         const refreshToken = localStorageObj._getRefreshToken()
//         return axios.post('api/token/refresh/', {refresh: refreshToken})
//                 .then(response => {
//                     if (response.status === 200){
//                         localStorageObj._updateAccess(response.data.access)
//                         axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.access}`
//                         return axios(originalRequest)
//                     }
//                 })
//     }
//     return Promise.reject(error);
// })

// export default axios


axios.interceptors.request.use(config => {

    config.baseURL = BASE_URL
    return config
}, error => {
    Promise.reject(error)
})

export default axios